export default __webpack_public_path__ + "static/media/healthcare-abroad.b4ed2301.png";